import type { ClaimWorkCounts } from '../../../store';

/** Keep queue badges on the newest canonical snapshot across per-view RTK caches. */
export const selectNewerClaimWorkCounts = (
  current: ClaimWorkCounts | undefined,
  incoming: ClaimWorkCounts | undefined,
): ClaimWorkCounts | undefined => {
  if (!incoming) return current;
  if (!current) return incoming;
  const currentComputedAt = Date.parse(current.computed_at);
  const incomingComputedAt = Date.parse(incoming.computed_at);
  if (!Number.isFinite(incomingComputedAt)) return current;
  if (!Number.isFinite(currentComputedAt)) return incoming;
  return incomingComputedAt >= currentComputedAt ? incoming : current;
};
